import { configureStore } from '@reduxjs/toolkit'
import appReducer  from './slices/appslice'

export default configureStore({
  reducer: {
    appData: appReducer
  },
})